import { HStack, Stack, Text } from '@chakra-ui/react';

import { UserCircleFrame } from '@/client/components/icons/ContinuIcons';
import type { User as UserType } from '@/client/types/User';
import { useAuthStore } from '@/client/services/state/authStore';

export default function CompanyInformationSection({ userData }: { userData: UserType }) {
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const { user_metadata_fields: userMetadataFields } = company;
  const { metadata } = userData;

  // Filter metadata entries based on visibility settings
  const visibleMetadataEntries = Object.entries(metadata)
    .filter(([key, value]) => {
      // Find the corresponding userMetadataField for this key
      const fieldConfig = userMetadataFields?.find((field) => field.name === key);

      // If no field config exists or visibility.profile is 'none', don't show it
      if (!fieldConfig || fieldConfig.visibility.profile === 'none') {
        return false;
      }

      // Don't show entries with empty string, null, or undefined values
      if (value === '' || value === null || value === undefined) {
        return false;
      }

      return true;
    })
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

  return (
    <Stack spacing={2}>
      {visibleMetadataEntries.map(([key, value]) => (
        <HStack key={key} spacing={2}>
          <UserCircleFrame />

          <Text fontSize="16px" fontWeight={400} color="baseBlack">{`${key}: ${value}`}</Text>
        </HStack>
      ))}
    </Stack>
  );
}
